export function state() {
  return {
    list: [],
  }
}

export const mutations = {
  SET_ITEMS: (state, payments) => (state.list = payments),
}

export const actions = {
  fetchItems({ commit, dispatch, state }, id) {
    dispatch('wait/start', 'customers.payments.index', { root: true })

    return this.$axios
      .$get(`/customers/${id}/payments`, {
        headers: {
          'X-Company-Id': localStorage.getItem('company-id'),
        },
      })
      .then((data) => {
        commit('SET_ITEMS', data.data)
        dispatch('wait/end', 'customers.payments.index', { root: true })
        return Promise.resolve(state.list)
      })
      .catch(() => {
        dispatch('wait/end', 'customers.payments.index', { root: true })
      })
  },
}
